import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { decodeData } from '../../../utils/encodeAndEncode';
import { getDocumentById } from '../../../services/adminService';
import Loader from '../../../components/admin/Loader';

function AdminDocumentView() {
    const { courseId, moduleId, contentId } = useParams();
    const decodedContentId = decodeData(contentId);
    const [loading, setLoading] = useState(true);
    const [documentData, setDocumentData] = useState({ name: '', pdfUrl: '' });

    useEffect(() => {
        const fetchDocument = async () => {
            try {
                setLoading(true);
                const response = await getDocumentById({ doc_id: decodedContentId });
                if (response.success && response.data) {
                    setDocumentData({
                        name: response.data.doc_name || 'Untitled Document',
                        pdfUrl: response.data.doc_url || ''
                    });
                }
            } catch (error) {
                console.error('Error fetching document:', error);
            } finally {
                setLoading(false);
            }
        };

        if (decodedContentId) {
            fetchDocument();
        }
    }, [decodedContentId]);

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <Loader />
            </div>
        );
    }

    return (
        <div className="px-4 md:px-8 py-5 max-w-6xl mx-auto">
            <div className="mb-6 flex items-center gap-3">
                <Link
                    to={`/admin/approvalRequest/view/${courseId}/content/${moduleId}`}
                    className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-gray-200 text-gray-600 hover:bg-gray-50 no-underline"
                    title="Back to Module Content"
                >
                    <Icon icon="fluent:arrow-left-24-regular" width={18} height={18} />
                </Link>
                <div>
                    <h1 className="text-xl md:text-2xl font-semibold text-gray-900 mb-0">Course Document</h1>
                    <p className="text-sm text-gray-500 mt-1 mb-0">{documentData.name}</p>
                </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="border-b border-gray-100 px-4 py-3">
                    <span className="text-sm font-medium text-gray-800">Document preview</span>
                </div>
                <div className="p-4 md:p-6">
                    {documentData.pdfUrl ? (
                        <div className="rounded-xl overflow-hidden border border-gray-100 bg-gray-50/50">
                            <iframe
                                src={documentData.pdfUrl}
                                title="Document Viewer"
                                className="w-full border-0 rounded-lg"
                                style={{ minHeight: '72vh' }}
                                allowFullScreen
                            />
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center py-16 rounded-xl border-2 border-dashed border-gray-200 bg-gray-50/50">
                            <Icon icon="fluent:document-24-regular" width={28} height={28} className="text-gray-400 mb-3" />
                            <p className="text-gray-600 font-medium mb-0">No document available</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AdminDocumentView;
